import React from 'react';
import { UiLegacy } from '@silvertours/front-legacy-shared';
import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';
import { SearchFormState, useSearchContext } from '../SearchFormLegacy/context';
import { SceneProps, WizardOverlay } from './common';

const Calendar = styled(UiLegacy.Calendar)`
  margin-left: -1rem;
`;

const getDays = (state: SearchFormState) => {
  if (state.depDate && state.destDate) {
    const from = new Date(state.depDate);
    const to = new Date(state.destDate);
    // Inspired by https://youmightnotneed.com/date-fns#differenceInDays,
    // because differenceInHours() from date-fns always rounds which is not what we want
    const HOUR_IN_MS = 1000 * 60 * 60;
    const days = ((to as any) - (from as any)) / HOUR_IN_MS / 24;
    return Number.isInteger(days) ? days : Math.ceil(days);
  }
  return 1;
};

const CalendarScene = (props: SceneProps) => {
  const { setDate, state } = useSearchContext();

  const t = useTranslations('features.stageLegacy.stage.searchForm');

  if (!state) {
    return null;
  }

  const dayCountText = t('dayCount', { days: getDays(state) });

  return (
    <WizardOverlay
      {...props}
      title="Select travel period"
      buttonText={dayCountText}
    >
      <Calendar
        from={new Date(state.depDate)}
        to={new Date(state.destDate)}
        onDatesChange={dates => {
          setDate('departure', dates.from!);
          setDate('destination', dates.to!);
        }}
        vertical
      />
    </WizardOverlay>
  );
};

export { CalendarScene };
